import { Component, OnInit, ViewChild } from '@angular/core';
import { Paginacao, Usuario} from '../../model';
import { DashboardService, LoginService } from '../../services';
import { Router } from '@angular/router';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as moment from "moment";
import 'moment/locale/pt-br'  // without this line it didn't work
import { TranslateService } from '@ngx-translate/core';
moment.locale('pt-br')


@Component({
  selector: 'ngx-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})

export class DashboardComponent implements OnInit {

  public CorPrimaria = window.getComputedStyle(document.documentElement).getPropertyValue("--CorPrimaria");
  public CorSecundaria = window.getComputedStyle(document.documentElement).getPropertyValue("--CorSecundaria");

  public lineChartDataSemanal: any[] = [ { data: [] , label: ''}];
  public lineChartLabelsSemanal: Label[] = [];

  public lineChartDataMensais: any[] = [ { data: [] , label: ''}];
  public lineChartLabelsMensais: Label[] = [];

  public lineChartDataPendentes: any[] = [ { data: [] , label: ''}];
  public lineChartLabelsPendentes: Label[] = [];

  public listStatusProdutos : any;

  public listAgenciasInativas : any;

  public lineChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };
  public lineChartColors: Color[] = [
    {
      borderColor: this.CorSecundaria,
      backgroundColor: this.CorSecundaria,
      hoverBackgroundColor: this.CorSecundaria
    },
  ];
  public lineChartLegend = true;
  public lineChartTypeBar = 'bar';
  public lineChartTypeLine = 'line';
  public lineChartPlugins = [];

  paginacao: Paginacao = new Paginacao();
  usuario: Usuario;


  constructor(private dashboardService: DashboardService, private translate: TranslateService, private loginService: LoginService, ) {  }

  ngOnInit() {
    setTimeout(() => {
      if (this.translate.currentLang == "pt") {
        this.lineChartDataSemanal = [{ data: [], label: 'Vendas Últimos 7 Dias' }];
        this.lineChartDataMensais = [{ data: [], label: 'Vendas Últimos 3 Meses' }];
        this.lineChartDataPendentes = [{ data: [], label: 'Vendas Pendentes' }];
      }
      else if (this.translate.currentLang == "en") {
        this.lineChartDataSemanal = [{ data: [], label: 'Sales Last 7 Days' }];
        this.lineChartDataMensais = [{ data: [], label: 'Sales Last 3 Days' }];
        this.lineChartDataPendentes = [{ data: [], label: 'Pending Sales' }];
      }
      else {
        this.lineChartDataSemanal = [{ data: [], label: 'Ventas Últimos 7 Días' }];
        this.lineChartDataMensais = [{ data: [], label: 'Ventas Últimos 3 Días' }];
        this.lineChartDataPendentes = [{ data: [], label: 'Ventas pendientes' }];
      }
    }, 600);
    this.usuario = this.loginService.user();
    // this.agenciasinativas();
    // this.vendassemanais();
    // this.vendasmensais();
    // this.vendaspendentes();
    // this.statusprodutos();
  }

  vendassemanais() {
    setTimeout(() => {
      this.dashboardService.GetVendasSemana().subscribe(
        dados => {
          dados = dados.map(x => {
            x.DataPagamento = moment(x.DataPagamento).format("dddd");
            x.DataPagamento = this.translate.instant(x.DataPagamento);
            return x;
          });
          for (const Item of dados) {
            this.lineChartLabelsSemanal.push(this.translate.instant(Item.DataPagamento));
            this.lineChartDataSemanal[0].data.push(Item.ValorTotalPago);
          }
        },
        erro => { }
      )
    }, 600);
  }

  vendasmensais() {
    setTimeout(() => {
      this.dashboardService.GetVendasMensais().subscribe(
        dados => {
          dados = dados.map(x => {
            x.DataPagamento = moment().month(x.DataPagamento - 1).format("MMMM");
            x.DataPagamento = this.translate.instant(x.DataPagamento);
            return x;
          });

          for (const Item of dados) {
            this.lineChartLabelsMensais.push(this.translate.instant(Item.DataPagamento));
            this.lineChartDataMensais[0].data.push(Item.ValorTotalPago);
          }
        },
        erro => { }
      )
    }, 600);
  }

  vendaspendentes() {
    this.dashboardService.GetVendasPendentes().subscribe (
      dados => {
        dados = dados.map(x => {
            x.Data = moment(x.Data).format("DD/MM/YYYY");
          return x;
        });
        for (const Item of dados) {
           this.lineChartLabelsPendentes.push(Item.Data);
           this.lineChartDataPendentes[0].data.push(Item.Total);
        }
      },
      erro => {}
    )
  }

  statusprodutos() {
    this.dashboardService.GetStatusProdutos().subscribe (
      dados => {
        this.listStatusProdutos = dados;
        // setTimeout(() => {
        //   this.listStatusProdutos = this.translate.instant(dados);
        // }, 600);
      },
      erro => {

      }
    )
  }

  agenciasinativas() {
    this.dashboardService.GetAgenciaInativas(this.paginacao.NumeroPagina).subscribe (
      dados => {
        this.listAgenciasInativas = dados.Items;

        this.paginacao.NumeroPagina = dados.MetaData.NumeroPagina;
        this.paginacao.TotalItens = dados.MetaData.TotalItens;
        this.paginacao.ItensPorPagina = dados.MetaData.itensPorPagina;
        this.paginacao.TotalPaginas = dados.MetaData.TotalPaginas;
      },
      erro => {

      }
    )
  }

  buscarPagina(pagina){
    this.paginacao.NumeroPagina = pagina;
    this.agenciasinativas();
  }

  // rankingconversao() {
  //   this.dashboardService.GetRankingConversao().subscribe (
  //     dados => {
  //       console.log(dados);
  //     },
  //     erro => {
  //
  //     }
  //   )
  // }

}
